/* eslint-disable react/jsx-handler-names */
import PropTypes from "prop-types";
import Link from "next/link";
import CustomImage from "../../../components/atoms/customImage";

/**
 * RedirectToCatalog component provides a styled link that directs users to a catalog page.
 * It displays a message, a link, and an image icon, and supports customization through props.
 *
 * @component
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.message - The message to display next to the link text.
 * @param {string} props.href - The URL to which the link should redirect.
 * @param {string} props.linkText - The text to display for the link.
 * @returns {React.ReactElement} A React component that renders a styled link with a message and an icon.
 */
const RedirectToCatalog = ({ message, href, linkText, onClickOverCatalog }) => {
  return (
    <div className="mt-16">
      <Link
        href={href}
        className={`relative flex rounded-full border-1 border-darkOliveGreen/10 bg-gradient-to-r from-[#D9DDB1] to-[#f9faf2] p-4 pr-40`}
        onClick={onClickOverCatalog}
      >
        <CustomImage src="/icons/same-day-link-icons.svg" width={40} height={40} className="mr-8" alt="same day icon" />
        <p className="flex flex-wrap items-center text-12 font-500 text-black-100">
          <span className="mr-8">{message}</span>
          <span className="font-600">{linkText}</span>
        </p>
        <div className="absolute inset-y-0 right-0 top-0 flex h-full items-center justify-center p-12">
          <CustomImage src="/icons/green-chevron.svg" width={16} height={16} isPriority={false} alt="green-chevron" />
        </div>
      </Link>
    </div>
  );
};
RedirectToCatalog.propTypes = {
  message: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  onClickOverCatalog: PropTypes.object,
};
export default RedirectToCatalog;
